import React, { FC } from 'react';

import { Spin } from 'antd';

import { useTranslate } from '@/hooks/use-translate';
import { DocData } from '@/types/legal';

import styles from './RussianSoftwareInfo.module.scss';

type Props = {
	documents: DocData[];
};

const en = {
	'Fishplace — российское ПО': 'Fishplace — Russian software',
	'Платформа работает на базе программного обеспечения для ЭВМ «Цифровая платформа Fishplace» регистрационный номер':
		'Platform works on the basis of the computer “Digital FishPlace Platform” Registration number',
	'ПО внесено в единый реестр российских программ под номером':
		'According to the Unified Register of Rosia programs under the number',
};

export const RussianSoftwareInfo: FC<Props> = ({ documents }) => {
	const t = useTranslate(en);

	if (!documents.length) {
		return <Spin size="large" />;
	}

	const firstDoc = documents.find((item) => item.title === '28219');
	const secondDoc = documents.find((item) => item.title === '2024683715');

	return (
		<section className={styles.importantDocumentsSection}>
			<div className={styles.content}>
				<h2 id="russianSoftware" className={styles.subtitle}>
					{t('Fishplace — российское ПО')}
				</h2>
				<div className={styles.description}>
					{t(
						'Платформа работает на базе программного обеспечения для ЭВМ «Цифровая платформа Fishplace» регистрационный номер',
					)}{' '}
					<a className={styles.link} href={firstDoc.file} target="_blank" rel="noreferrer">
						№2024683715.
					</a>
					<br />
					<br />
					{t('ПО внесено в единый реестр российских программ под номером')}{' '}
					<a className={styles.link} href={secondDoc.file} target="_blank" rel="noreferrer">
						№28219.
					</a>
				</div>
			</div>
		</section>
	);
};
